import {
  selectUI,
  titleUI,
} from '@department-of-veterans-affairs/platform-forms-system/web-component-patterns';

import {
  stateLabels,
  stateSelectSchema,
} from '../../schema-helpers/state-select';

const pageTitle = 'State of school';

const stateOfSchoolPage = {
  uiSchema: {
    ...titleUI(pageTitle),
    stateOfTheSchool: selectUI({
      title: 'Select state',
      labels: stateLabels,
      errorMessages: {
        required: 'Select state of school',
      },
    }),
  },
  schema: {
    type: 'object',
    required: ['stateOfTheSchool'],
    properties: {
      stateOfTheSchool: stateSelectSchema,
    },
  },
  title: pageTitle,
};

export default stateOfSchoolPage;
